// Attributes that ask the common browser password managers to ignore an input. Search and command/autocomplete boxes
// are never credential fields, but password managers frequently mistake them for username/password boxes and cover them
// with their autofill overlay. Annoyingly, each password manager has their own unique opt-out attribute.
//
// To use, spread these onto such an input to opt it out:
//
//   <input {...passwordManagerIgnoreProps} ... />
//
// Coverage:
//   - Bitwarden  -> data-bwignore
//   - 1Password  -> data-1p-ignore
//   - LastPass   -> data-lpignore
//   - Dashlane   -> data-form-type="other"
//
// Each manager only checks for the attribute's presence (the values are arbitrary), but we set explicit values for
// readability.
export const passwordManagerIgnoreProps = {
  'data-bwignore': 'true',
  'data-1p-ignore': 'true',
  'data-lpignore': 'true',
  'data-form-type': 'other'
} as const;
